import { http } from './http';

export interface Field { name: string; title: string; datatype: string; unique: boolean; required: boolean; folderfield: boolean; }
export interface Document { id: number; name?: string; [key:string]: any; }

export async function getDrawerFields(drawerId:number): Promise<Field[]> { return http(`/api/field/bydrawer?drawerid=${drawerId}`); }
export async function getFolderFields(drawerId:number): Promise<Field[]> { return (await getDrawerFields(drawerId)).filter(f=>f.folderfield); }
export async function getDocumentFields(drawerId:number): Promise<Field[]> { return (await getDrawerFields(drawerId)).filter(f=>!f.folderfield); }

// Backend expects POST body with filter/order/take/continuationToken
interface SearchPostBody { filter:string; orderBy?:string; take?:number; continuationToken?:string; }

export interface SearchResponse<T> { values: T[]; continuationToken?: string; ContinuationToken?: string; }

export async function searchDocuments(drawerId:number, criteria:Record<string, {operator:string; value:string}>, orderBy?:string, take:number=50, continuationToken?:string){
  let filter = `drawer eq ${drawerId}`;
  Object.entries(criteria).forEach(([field,{operator,value}])=> { if(value) filter += ` and ${field} ${operator} ${value}`; });
  const body:SearchPostBody = { filter, orderBy, take, continuationToken } as any;
  const data:SearchResponse<Document> = await http('/api/document/search',{ method:'POST', json: body });
  const items = (data as any).Values ?? data.values ?? [];
  return { items, continuationToken: (data as any).ContinuationToken ?? data.continuationToken ?? null };
}

export async function getDocumentById(id: number) { return http(`/api/document/${id}`); }
export async function getDocumentUri(id: number, download: boolean) { return http(`/api/document/${id}/uri?forcedownload=${download}`); }
